import { render } from "./MGNavPanel.vue?vue&type=template&id=f36737f4&scoped=true"
import script from "./MGNavPanel.vue?vue&type=script&lang=js"
export * from "./MGNavPanel.vue?vue&type=script&lang=js"

import "./MGNavPanel.vue?vue&type=style&index=0&id=f36737f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36737f4"]])

export default __exports__